<p-multiSelect
  [appendTo]="appendTo"
  [ngClass]="{
    'm-multiselect m-checkbox': true,
    'is-draggable': isDraggable,
    'ng-invalid': !isValid,
  }"
  [filterPlaceHolder]="filterPlaceHolder"
  [maxSelectedLabels]="maxSelectedLabels"
  [(ngModel)]="value"
  (ngModelChange)="onModelChange($event)"
  [options]="options"
  (onPanelShow)="handlePanelShow()"
  [placeholder]="placeholder()"
  [selectedItemsLabel]="selectedItemsLabel"
  [style]="{ width: width, height: height }">
</p-multiSelect>
